var deDeTranslation = {
    "contact_us.buttonText": "Hilfe",
    "contact_us.error.email": "Bitte gib eine g\xfcltige E-Mail ein",
    "contact_us.error.general": "Ups... Etwas ist schief gelaufen. Probier erneut.",
    "contact_us.error.minimum_two_chars": "Sollte mind. 2 Zeichen lang sein",
    "contact_us.placeholders.email": "E-Mail-Adresse",
    "contact_us.placeholders.name": "Voller Name",
    "contact_us.placeholders.text": "Wie k\xf6nnen wir helfen?",
    "contact_us.send": "Senden",
    "contact_us.subtitle": "F\xfclle deine Daten aus, schreibe uns dein Anliegen und wir setzen uns mit dir in Verbindung.",
    "contact_us.success.ok": "Ok",
    "contact_us.success.subtitle": "Wir haben deine Nachricht erhalten und melden uns in K\xfcrze bei dir.",
    "language.select.label": "W\xe4hlen Sie Ihre Sprache",
    "contact_us.success.title": "Danke {{name}}!",
    "contact_us.title": "Hast du Fragen an uns?",
    "cookie_consent.customize.categories.essential.description": "Diese Cookies sind dazu da, dir das bestm\xf6gliche Erlebnis zu bieten und sind f\xfcr das Funktionieren unserer Webseite notwendig, ohne pers\xf6nliche Daten an Dritte weiterzugeben.",
    "cookie_consent.customize.categories.essential.title": "Notwendige Cookies (immer aktiviert)",
    "cookie_consent.customize.categories.performance.description": "Diese Cookies helfen uns dabei, die Leistung zu ermitteln und Besuche auf unserer Webseite genauer zu analysieren, damit wir auch weiterhin unser Nutzererlebnis verbessern, sowie Angebote personalisieren k\xf6nnen.",
    "cookie_consent.customize.categories.performance.title": "Leistungs-Cookies",
    "cookie_consent.customize.confirm_btn_title": "BEST\xc4TIGEN",
    "cookie_consent.customize.title": "Cookies Anspassen",
    "cookie_consent.information.accept_btn_title": "akzeptieren",
    "cookie_consent.information.cookies_policy_link_text": "Cookie-Richtlinie",
    "cookie_consent.information.customize_btn_title": "anpassen",
    "cookie_consent.information.description": "Wir verwenden Cookies und andere Technologien, um dir das bestm\xf6gliche Nutzererlebnis zu bieten und um die Werbung auf unserer Webseite und au\xdferhalb individuell zu gestalten. Dar\xfcber hinaus k\xf6nnen unsere Partner Cookies oder andere Technologien einsetzen, um dir m\xf6gliche Marketinginformationen zukommen zu lassen. Wenn du alle nicht notwendigen Cookies deaktivieren m\xf6chtest, klicke auf „Anpassen”. Mehr dar\xfcber, wie wir Cookies nutzen und dein Recht dazu, diese zu deaktivieren, findest du in unserer Cookie-Richtlinie.",
    "cookie_consent.information.title": "lemonade und cookies",
    "cxai.browser_toast": "F\xfcr ein optimales Chat-Erlebnis empfehlen wir die\nBrowser Chrome, Safari oder Edge",
    "cxai.default_description": "Pers\xf6nliche Versicherungsassistentin",
    "cxai.error.message": "Etwas ist schief gelaufen",
    "cxai.error.retry": "Wiederholen",
    "cxai.phone_input.mobile_title": "",
    "cxai.phone_input.no_results": "",
    "cxai.phone_input.placeholder": "",
    "cxai.restart.action": "JACTAs",
    "cxai.restart.close": "NEIN",
    "cxai.restart.content": "Brauchst du noch bei \netwas anderem Hilfe?",
    "cxai.restart.title": "Von vorne beginnen",
    "error_page.action": "ZUR\xdcCK ZUR STARTSEITE",
    "error_page.subtitle": "Seite wurde nicht gefunden...",
    "error_page.title": "Ups.",
    "footer.disclaimer": "*F\xfcr Hausratversicherungen im PLZ-Gebiet 10437 mit einem Deckungsbetrag von 10.000 € (Nutzungsausfall nicht inbegriffen).\nF\xfcr Hausrat- & Privathaftpflichtversicherungen einschlie\xdflich einer zus\xe4tzlichen Haftpflichtdeckung von 2 € /Mo.",
    "footer.titles.company": "unternehmen",
    "footer.titles.privateLiabilityInsurance": "Privathaftpflichtversicherung",
    "footer.titles.features": "besonderheiten",
    "footer.titles.homeContentInsurance": "Hausratversicherung",
    "footer.titles.get_app": "download unsere App",
    "footer.titles.products": "",
    "footer.titles.resources": "ressourcen",
    "footer.titles.social": "folge uns auf",
    "footer.titles.contact": "Kontaktiere uns",
    "header.actions.login": "Mein Account",
    "header.actions.logout": "Ausloggen",
    "header.actions.settings": "Einstellungen",
    "header.homeowners.title": "",
    "nav.accessibility.title": "Barrierefreiheit",
    "nav.api.title": "API",
    "nav.blank.title": "",
    "nav.blog.title": "Blog",
    "nav.car.title": "",
    "nav.car_explained.title": "",
    "nav.claims.title": "Schadensabwicklung",
    "nav.community.title": "Community",
    "nav.covid_19.title": "",
    "nav.expats_de.title": "",
    "nav.expats_nl.title": "",
    "nav.faq.title": "FAQ",
    "nav.giveback.title": "Giveback",
    "nav.giveback_2021.title": "Giveback",
    "nav.blog_en_de_liability_insurance_germany.title": "Blog",
    "nav.global_expansion.title": "Wo wir erh\xe4ltlich sind",
    "nav.home.title": "Home",
    "nav.homeowners.title": "",
    "nav.imprint.title": "",
    "nav.insurance_card.title": "",
    "nav.insuropedia.title": "Versicherungslexikon",
    "nav.investors.title": "",
    "nav.legal_stuff.title": "Rechtliches",
    "nav.life.title": "",
    "nav.facts_insurance_hub.title": "Thema Schl\xfcsselversicherung",
    "nav.multiple_insurance_hub.title": "Was ist eine Mehrfachversicherung?",
    "nav.insurance_policies_hub.title": "Welche Versicherungen braucht man?",
    "nav.insurance_as_tenant.title": "Welche Versicherungen als Mieter?",
    "nav.makers.title": "Join the Team",
    "nav.global_blog_de.title": "Blog",
    "nav.impressum.title": "Impressum",
    "nav.manage_cookies.title": "Cookies verwalten",
    "nav.partners_program.title": "Partners Program",
    "nav.costs_home_contents_insurance_hub.title": "Kosten f\xfcr die Hausratversicherung",
    "nav.personal_liability_hub.title": "Privathaftpflichtversicherung verstehen",
    "nav.pet.title": "",
    "nav.external_insurance_hub.title": "Aussenversicherung",
    "nav.homeowners_insurance_hub.title": "Wohngeb\xe4udeversicherung",
    "nav.content_insurance_hub.title": "Hausratversicherung meistern",
    "nav.pet_dog_insurance_explained.title": "",
    "nav.pet_insurance.title": "",
    "nav.policy_two.title": "Police 2.0",
    "nav.privacy_policy.title": "Datenschutzinformation",
    "nav.renters.title": "",
    "nav.renters_hub.title": "Hausratversicherung verstehen",
    "nav.reviews.title": "",
    "nav.sitemap.title": "Sitemap",
    "nav.term_life.title": "",
    "nav.terms_of_service.title": "Nutzungsbedingungen",
    "nav.transparency.title": "Transparency",
    "header.accessibility.title": "Barrierefreiheit",
    "header.api.title": "API",
    "header.blank.title": "",
    "header.blog.title": "Blog",
    "header.car.title": "",
    "header.car_explained.title": "",
    "header.claims.title": "Schadensabwicklung",
    "header.community.title": "Community",
    "header.covid_19.title": "",
    "header.expats_de.title": "",
    "header.expats_nl.title": "",
    "header.faq.title": "FAQ",
    "header.giveback.title": "Giveback",
    "header.giveback_2021.title": "Giveback",
    "header.global_expansion.title": "Wo wir erh\xe4ltlich sind",
    "header.home.title": "Home",
    "header.imprint.title": "",
    "header.insurance_card.title": "",
    "header.insuropedia.title": "Versicherungslexikon",
    "header.investors.title": "",
    "header.legal_stuff.title": "Rechtliches",
    "header.life.title": "",
    "header.makers.title": "Join the Team",
    "header.impressum.title": "Impressum",
    "header.manage_cookies.title": "Cookies verwalten",
    "header.partners_program.title": "Partners Program",
    "header.personal_liability_hub.title": "Haftpflicht verstehen",
    "header.pet.title": "",
    "header.pet_dog_insurance_explained.title": "",
    "header.pet_insurance.title": "",
    "header.policy_two.title": "Police 2.0",
    "header.privacy_policy.title": "Datenschutzinformation",
    "header.renters.title": "",
    "header.renters_hub.title": "Versicherungstipps",
    "header.reviews.title": "",
    "header.sitemap.title": "Sitemap",
    "header.term_life.title": "",
    "header.terms_of_service.title": "Nutzungsbedingungen",
    "header.transparency.title": "Transparency",
    "privacy_banner.content": "Wir verwenden Cookies und andere Technologien, um dir die bestm\xf6gliche Benutzererfahrung zu bieten, sowie um Werbung auf und au\xdferhalb unserer Website anzupassen. Dar\xfcber hinaus verwenden unsere Partner m\xf6glicherweise Cookies und andere Technologien, um dir Werbeinformationen zur Verf\xfcgung zu stellen. Lies mehr dazu sowie \xfcber dein Recht auf Widerspruch in unserer [Datenschutzrichtlinie](privacyPolicyLink).",
    "privacy_banner.cta": "AKZEPTIEREN",
    "cookie_consent.information.reject_btn_title": "Ablehnen",
    "cookie_consent.customize.categories.tracking.title": "Targeting-/Werbe-Cookies",
    "cookie_consent.customize.categories.tracking.description": "Dies sind Marketing-Cookies, die uns dabei helfen, m\xf6glichst personalisierte Angebote zu erstellen",
    "nav.do_not_share_my_personal_information.title": "Teile nicht meine pers\xf6nlichen Daten",
    "cookie_consent.customize.personalInfo.block3.description": "Wenn du ein Konto bei uns hast und deine Daten \xe4ndern oder l\xf6schen m\xf6chtest, schicke uns einfach eine E-Mail an privacy@lemonade.com oder rufe uns geb\xfchrenfrei an unter 844-733-8666",
    "cookie_consent.customize.personalInfo.block1.description": "Wir nutzen die durch Cookies gesammelten Informationen, um dir das bestm\xf6gliche Erlebnis zu bieten. Aber, keine Sorge, du kannst die Cookies jederzeit deaktivieren. Als Einwohner Kaliforniens hast du Rechte bez\xfcglich des Verkaufs deiner pers\xf6nlichen Daten."
};

export { deDeTranslation as default };
